if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.cart = document.querySelector('cart-items');
      this.cartDrawer = document.querySelector('cart-drawer');
      
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const sectionsToFetch = [
        ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
        ...this.cartNotification.getSectionsToRender().map((section) => section.id)
      ];

      const formData = new FormData(this.form);
      formData.append('sections', sectionsToFetch);
      formData.append('sections_url', window.location.pathname);

      // add additional Form data if it exists - Used for the Gift card recipient form in the PDP
      if (evt.detail != undefined && evt.detail.additionalFormData != undefined) {
        for (const [key, value] of Object.entries(evt.detail.additionalFormData)) {
          formData.append(key, value);
        }
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status == 422) {
            // When quantity error
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
            return;
          }

          // get the user loyalty points and pass it when rendering the cart (the value is gone on add to cart)
          let loyaltyPointsBalance;
          const loyaltyPointsWrapper = document.querySelector('[data-custom-point-balance-ui]');
          loyaltyPointsWrapper != null ? loyaltyPointsBalance = loyaltyPointsWrapper.innerHTML : '';
          this.cartDrawer.renderContents(parsedState,loyaltyPointsBalance);

          // update the shipping bar
          this.cart.updateShipping(parsedState);

          // close the recipient gift card modal and reset the form fields on ATC 
          this.recipientForm = document.querySelector('recipient-form');
          if (this.recipientForm) {
            this.recipientForm.querySelector('[data-recipient-form-modal]').classList.remove('modal-is-open');
            this.recipientForm.querySelector('[data-recipient-form]').reset();
          }

          switch (submitButton.dataset.addToCartBehavior) {
            case ('open_cart_drawer'):
              this.cartDrawer.open();
              break;
            case ('show_cart_notification'):
            default:
              this.cartNotification.setActiveElement(document.activeElement);
              this.cartNotification.renderContents(parsedState,loyaltyPointsBalance);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }

  }

  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);
}